/* unplugin-vue-components disabled */import script from "./PBSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PBSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./PBSnackbar.vue?vue&type=style&index=0&id=832beb1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-832beb1e"]])

export default __exports__